import VTable from '@/vuetify_custom/v-table/v3'
import VPage from '@/vuetify_custom/v-pagination'
import { getAccountFinanceBalanceMonthlyLedgerQueryDifferenceApi } from './service'
import {account_type_list} from './fields'
export default {
    props: {
        outParams: {
            type: Object,
            default: () => ({})
        },
        tableHeight: {
            type: Number,
            default: () => 100
          }
    },
    data() {
        return {
            loading: false,
            params: {
                page:1,
                per_page:10,
                total_count: 0,
              },
            list: []
        }
    },
    computed: {
        table_fields() {
            return [
                {
                    text: '公司',
                    align: 'center',
                    value: 'company_name',
                    width: 120,
                    fixed: 'left',
                    z_index: 3,
                    style_header: {
                        'z-index':4,
                    }
                },
                {
                    text: '账户名称',
                    align: 'center',
                    value: 'account',
                    width: 150,
                },
                {
                    text: '账户号',
                    align: 'center',
                    value: 'account_number',
                    width: 100,
                },
                {
                    text: '开户银行',
                    align: 'center',
                    value: 'bank_branch',
                    width: 150,
                },
                {
                    text: '币种', 
                    align: 'center',
                    value: 'currency',
                    width: 60,
                },
                {
                    text: '结算方式',
                    align: 'center',
                    value: 'settle_type',
                    type: 'list_field',
                    item_key: 'key',
                    item_text: 'title',
                    items: account_type_list,
                    default_value: '-',
                    width: 100,
                },
                // {
                //     text: '账户性质',
                //     align: 'center',
                //     value: 'account_property',
                //     width: 110,
                //     type: 'list_field',
                //     item_key: 'key',
                //     item_text: 'title',
                //     items: [
                //         {
                //             title: '基本户',
                //             key: 1,
                //         },
                //         {
                //             title: '一般户',
                //             key: 2,
                //         },
                //         {
                //             title: '资本金账户',
                //             key: 3,
                //         },
                //         {
                //             title: '结算户',
                //             key: 4,
                //         },
                //         {
                //             title: '结汇待支付户',
                //             key: 5,
                //         }
                //     ]
                // },
                {
                    text: '本月流入',
                    type: 'money_field',
                    value: 'inflow',
                    width: 150,
                },
                {
                    text: '本月流出',
                    type: 'money_field',
                    value: 'outflow',
                    width: 150,
                },
                {
                    text: '期末余额',
                    type: 'money_field',
                    value: 'ending_balance',
                    width: 150,
                },
                {
                    text: '账户余额',
                    type: 'money_field',
                    value: 'current_balance',
                    width: 150,
                },
            ]
        },
    },
    methods: {
        getData(_params = {}) {
            this.loading = true
             // eslint-disable-next-line
            const { total_count, ...other_params } = this.params
            getAccountFinanceBalanceMonthlyLedgerQueryDifferenceApi({
                ...this.outParams,
                ...other_params,
                ..._params
            }).then(res => {
                this.list = res.list
                this.params.total_count = res.total_count
                this.params.per_page = res.per_page
                this.params.page = res.page
            }).finally(() => {
                this.loading = false
            })
        }
    },
    render() {
        return <div>
            <VTable
                fixedHeader
                height={`${this.tableHeight}px`}
                loading={this.loading}
                headers={this.table_fields}
                desserts={this.list}/>
            <div class="paginate-fix-bottom">
             {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                      this.getData({
                        page:1,
                        per_page
                      })
                    },
                    pageChange:(page) => {
                      this.getData({
                        page
                      })
                    }
                  }
                }
              />}
            </div>
        </div>
    }
}